module.exports = __webpack_public_path__ + "img/doc__uz__passport.2b1afe70.png";